import styled from 'styled-components';
import BGBanner from '../../assests/images/bg-banner.webp';

export const FaqBanner = styled.section`
    background-image:url(${BGBanner});
    background-color:#ddf5f6;
    padding:60px 0 30px 0;

    @media screen and (max-width: 1024px){
        padding: 173px 0 30px 0
    }
`;

export const FaqTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: 700;
    line-height: 60px;
    margin-bottom: 20px;
    text-align: center;

    @media screen and (max-width: 991px){
        font-size: 36px;
        line-height: 56px;
    }

    @media screen and (max-width: 767px){
        font-size: 32px;
        line-height: 52px;
        margin-bottom: 15px;
    }

    @media screen and (max-width: 575px){
        font-size: 28px;
        line-height: 40px;
    }
`;

export const FaqText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 15px;
    text-align: center;  

    &.faqs-text{
        color: #01606F;
        margin-bottom: 0;
        text-align: left;
    }

    &.heading-tag-line{
        &:last-child{
            margin-bottom: 0;
        }
    }
`;

export const MainTabSection = styled.div`
    padding-bottom: 60px;
    position: relative;
    @media screen and (max-width: 991px){
        padding-bottom: 50px;
    }
    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }

    &.main-tab-bg{
        position: relative;
        
        &:after{
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;
            background-color: #ddf5f6;
            max-height: 320px;
        }
    }
    
    &:after{
        background: #F1FEFF 0% 0% no-repeat padding-box;
        position: absolute;
        width:100%;
        height:100%;
        content:"";
        top:0;
        z-index: -1;
    }

    .nav-tabs{
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 15px;
        padding: 6px;
        justify-content: space-between;
        margin: 0 auto 37px auto;
        max-width: 660px;
        width: 100%;

        .nav-item{
            width: 50%;
            &:last-child{
                .nav-link{
                    border-right:none;
                }
            }
            .nav-link{
                color: #01606F;
                font-family: "Jost", sans-serif;
                font-size:20px;
                font-weight: 500;
                line-height: 29px;
                padding: 10px 20px;
                border: none;
                border-radius: 10px;
                
                @media screen and (max-width: 575px){
                    font-size:16px;
                    line-height: 26px;
                    padding: 10px 20px;
                }

                @media screen and (max-width: 480px){
                    padding: 10px 10px;
                }
                
                &.active,&:hover{
                    background: #01606F 0% 0% no-repeat padding-box;
                    color:#fff;
                } 
            }
        }
    }
`;


export const FaqTabSection = styled.div`
    .nav-item{
        width: 50%;
    }
`;

export const FaqSearch = styled.div`
   .search-header{
    max-width: 792px;
    margin: 0 auto;
    
    .zipcode.input-group{
        display:none;
    }
    .btn-outline-success{
        padding: 12px 73px;

        @media screen and (max-width: 480px){
            width: 100%;
        }
    }
    .search-icon{
        display:none;
    }
    .form-control{
        padding-left: 15px !important;
    }
   }

   .form-control{
        min-width: 550px;
        
        @media screen and (max-width: 991px){
            min-width: 500px;
        }

        @media screen and (max-width: 767px){
            min-width: 320px;
        }

        @media screen and (max-width: 480px){
            min-width: 300px;
        }
        
        @media screen and (max-width: 420px){
            min-width: 270px;
        }
    }
`;

export const HelpSection = styled.div`
    position: relative;
`;

export const WeHelp = styled.div`
   display:flex;
   background: #F3F3F3;
   border-radius: 10px;
   padding:23px;
   justify-content: space-between;
   align-items: flex-start;
   gap: 25px;

   @media screen and (max-width: 991px){
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    @media screen and (max-width: 575px){
            gap: 20px;
    }

`;
export const HelpBox = styled.div`
    text-align: center;
    width: 100%;
    max-width: 215px;

    @media screen and (max-width: 991px){
        width: calc(33.33% - 17px);
        max-width: inherit;
    }

    @media screen and (max-width: 767px){
        width: calc(50% - 17px);
    }
    @media screen and (max-width: 420px){
        width: 100%;
    }
`;
export const BoxImage = styled.div`
    width: 105px;
    height: 105px;
    margin: 0 auto;
    
    @media screen and (max-width: 991px){ 
        width: 80px;
        height: 80px;
    }

    @media screen and (max-width: 575px){ 
        width: 60px;
        height: 60px;
    }

    img{
        width: 100%;
        height:100%;
        display: block;
        object-fit: cover;
    }
`;

export const BoxTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom:25px;
    margin-top: 38px;
    min-height: 3em;

    @media screen and (max-width: 991px){ 
        min-height: inherit;
        font-size:18px
         line-height: 28px;
    }
    @media screen and (max-width: 575px){
        margin-bottom:15px;
        margin-top: 20px
    }
`;

export const HowHelp = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 20px #0000001A;
    border-radius: 15px;
    padding:10px;
    margin-top: 50px;

    @media screen and (max-width: 575px){
        margin-top: 40px;
    }
`;
export const BoxText = styled.p`
   
    margin-bottom:0px;

    &.box-title-text{
        color: #333333;
        font-size:20px;
        font-weight: 600;
        line-height: 26px;
        margin-bottom: 20px;
    }
`;
export const BoxContent = styled.div`
    height: 100%;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:19px;
    font-weight: 400;
    line-height: 30px;
    margin-bottom:0px;

    @media screen and (max-width: 991px){
        font-size: 16px;
        line-height: 26px;
    }
`;

export const KnowledgeBase = styled.div`
    // background: #F1FEFF 0% 0% no-repeat padding-box;
    // padding-bottom:50px;
    max-width: 996px;
    margin: 0 auto;
`;

export const MostRecent = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 20px #0000001A;
    border-radius: 20px;
    width:100%;
    max-width:996px;
    margin:50px auto 0 auto;
    padding:20px;

    @media screen and (max-width: 575px){
        padding:15px;
    }

   .breadcrumb{
        background: #DDF5F6 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 20px #0000000D;
        border-radius: 10px;
        display: inline-flex;
        padding: 10px 18px;

        .breadcrumb-item {
            color: #01606F;
            font-family: "Jost", sans-serif;
            font-size:14px;
            font-weight:700;
            line-height: 20px;
            
            &:before{
                color: #01606F;
            }

            a{
                text-decoration: none;
                color: #01606F;
                font-family: "Jost", sans-serif;
                font-size:14px;
                font-weight:400;
                line-height: 20px;
            }
        }
    }
`;

export const KnowledgeTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 700;
    line-height: 43px;
    margin-bottom: 10px;

    @media screen and (max-width: 991px){ 
        font-size:28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){ 
        font-size:26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){ 
        font-size:26px;
        line-height: 36px;
    }
`;

export const KnowledgeSmallText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 15px;
    border-bottom: 1px solid rgb(0 0 0 / 20%);
    padding-bottom: 20px;
`;

export const KnowledgeSubTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height:27px;
    margin-bottom: 20px;
`;

export const ArticlesBox = styled.div`
    display: flex;
    gap: 15px;
    background: #F2F2F2 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 20px;

    @media screen and (max-width: 480px){ 
        flex-direction: column;
    }

    &:last-child{
        margin-bottom: 0px;
    }
`;

export const EllipsisText = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 600px; 
`;
export const ArticlesIcon = styled.div`
    background: #F7931E 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width:36px;
    min-width:36px;
    height:36px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ArticlesText = styled.div`

`;

export const Question = styled.h3`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight:700;
    line-height:21px;
    margin-bottom: 10px;
`;
export const Answer = styled.p`
    color:#333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight:400;
    line-height:21px;
    margin-bottom: 0px;
`;

export const ArticlesButton = styled.div`
    text-align: center;
`;

export const SolutionTabSection = styled.div`

`;

export const UserGuideWrapper = styled.div`
    margin-top: 30px;
`;
export const UserGuideSolution = styled.div`

`;

export const UserGuideTitle = styled.h3`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom:15px;

    &.light-blue-title{
        color: #33A7AE;
    }
`;

export const UserGuideGroup = styled.div`

    // display: flex;
    // align-items: flex-start;
    // flex-wrap: wrap;
    // gap: 20px 24px;

    &.user-guide-group{
        width: 100%;
    }

    &.user-guide-group-box{
        column-count: 2;
        counter-reset: item-counter;

        @media screen and (max-width: 991px){
            column-count: 1;
        }
    }
`;

export const UserGuideBox = styled.div`
    background: #F2F2F2 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:20px;
    // margin-bottom: 20px;

    // width: 100%;

    width: 100%;
    break-inside: avoid;
    margin-bottom: 20px;

    @media screen and (max-width: 767px){
        width: 100%;
    }

    &:last-child{
        margin-bottom: 0px;
    }
`;

export const Title = styled.h4`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 600;
    line-height: 21px;
    margin-bottom:15px;
    padding-bottom:20px;
    border-bottom: 1px solid #FFFFFF;
`;

export const UserGuideList = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;
`;
export const UserGuideItem = styled.li`
    color: #333333;
    cursor:pointer;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height:21px;
    margin-bottom: 20px;
    display: flex;
    gap:10px;
    align-items: center;

    @media screen and (max-width: 767px){
        align-items: flex-start;
    }
`;

export const UserGuideIcon = styled.span`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width:30px;
    height:30px;
    min-width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 767px){
        width: 26px;
        height: 26px;
        min-width: 26px;
        border-radius: 5px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        max-width: 16px;
    }
`;

export const UserGuideButton = styled.div`
    .view-all-article{
        padding: 12px 20px !important;
        
        @media screen and (max-width: 767px){
            width: 100%;    
            padding: 12px;
            border-radius: 6px;
        }
    }
`;


export const UserGuideSection = styled.div`
  
`;

export const UserGuideStarted = styled.div`
    background: #F2F2F2 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:20px;
    @media screen and (max-width: 575px)}{
        padding:15px;
    }
`;

export const StartedTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 600;
    line-height: 21x;
    margin-bottom: 10px;
`;

export const StartedText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27x;
    margin-bottom: 20px;
    padding-bottom:20px;
    border-bottom: 1px solid #FFFFFF;
`;

export const UserGuideStartedTitle = styled.h3`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:20px;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 15px;
`;

export const UserGuideStartedList = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
`;
export const UserGuideStartedItem = styled.li`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    gap:8px;


    @media screen and (max-width: 480px){
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const GuideStartedIcon = styled.span`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width:50px;
    height:50px;
    min-width:50px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 991px){
       width:30px;
        height:30px;
        min-width:30px;
        border-radius: 6px;
    }

    @media screen and (max-width: 480px){
        border-radius: 5px;
    }

    img{
        width: 100%;
        height: auto;
        max-width: 26px;
        display: block;
        object-fit: cover;

        @media screen and (max-width: 991px){
            max-width: 16px;
        }
    }
`;

export const GuideStartedText = styled.div`
    color:#000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height: 21px;
    display: flex;
    flex-direction: column;
    row-gap: 7px;
`;

export const GuideStartedTitle = styled.h4`
    color:#01606F;
    cursor:pointer;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height: 21px;
    margin-bottom: 0px;
`;
export const GuideStartedContent = styled.p`
    margin-bottom: 0px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-width: 614px;
`;

export const GettingStartedWrapper = styled.div`

`;

export const GettingStartedTitle = styled.h3`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 10px;
`; 

export const GettingStartedText = styled.p`
    color:#333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 20px;
    
    a{
        color:#01606F;
        font-weight: 700;
        text-decoration: none;
    }
`;

export const GettingText = styled.div`
    background: #F2F2F2 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:20px;
`;

export const GettingSubText = styled.div`
    margin-top: 33px;
    color:#000000;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const LinkIconOrange = styled.div`
    svg{
        fill: transparent;
        cursor: pointer;
        #Vector,#Vector-2{
            stroke: #f7931e;
        }
        // &:hover,
        // &.active{
        //     #Vector,    
        //     #Vector-2{
        //         fill: #f7931e;
        //         stroke: none;
        //     }
        // }
    }
`;

export const LinkIconBlack = styled.div`

    svg{
        transform: rotate(180deg);

        fill: transparent;
        cursor: pointer;
        #Vector,#Vector-2{
            stroke: #555555;
        }
        // &:hover,
        // &.active{
        //     #Vector,    
        //     #Vector-2{
        //         fill: #555555;
        //         stroke: none;
        //     }
        // }
    }
`;

export const RelatedArticles = styled.div`
    margin-top:30px;
`;

export const RelatedArticlesTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 27px;
`;

export const RelatedArticlesList = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
`;

export const RelatedArticlesItem = styled.li`
    display: flex;
    gap:10px;
    margin-bottom: 15px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height: 27px;
    cursor: pointer;
`;
 
export const RelatedArticlesIcon = styled.span`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width:30px;
    height:30px;
    min-width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    img{
        width: 100%;
        height: 100%;
        display: block;
        max-width: 16px;
    }
`;

